var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 13.167H4.06566L11.1977 6.035L10.4657 5.303L3.33366 12.435V13.167ZM2.66699 13.8337V12.1537L11.4537 3.359C11.5225 3.29811 11.5981 3.251 11.6803 3.21767C11.7625 3.18434 11.8485 3.16745 11.9383 3.167C12.0281 3.16656 12.1148 3.18078 12.1983 3.20967C12.2828 3.23767 12.3605 3.28834 12.4317 3.36167L13.143 4.07767C13.2163 4.14834 13.2665 4.22611 13.2937 4.311C13.3203 4.39545 13.3337 4.47989 13.3337 4.56434C13.3337 4.655 13.3185 4.74167 13.2883 4.82434C13.2577 4.90656 13.2092 4.98189 13.143 5.05034L4.34633 13.8337H2.66699ZM10.8257 5.675L10.4657 5.303L11.1977 6.035L10.8257 5.675Z",
    fill: "#F6AF3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6a2aaf0ed21b54c7f0cf414088a8c33b.svg";
export { ForwardRef as ReactComponent };